import { createApp } from 'vue'
import { ObserveVisibility } from 'vue-observe-visibility'
import HorseSearch from './HorseSearch.vue'

const searchApp = createApp(HorseSearch)
searchApp.directive('observe-visibility', {
  beforeMount: (el, binding, vnode) => {
    vnode.context = binding.instance
    ObserveVisibility.bind(el, binding, vnode)
  },
  update: ObserveVisibility.update,
  unmounted: ObserveVisibility.unbind
})
window.vuesearchapp = searchApp